import React from 'react';
import MicrophoneError from './MicrophoneError';

export default function RecordingMessageError({ type, titleOnly }) {
  return (
    <div
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 72, // new height of the bar
        zIndex: 1300,
        background: '#fffbe6',
        border: '1px solid #ffe58f',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px 16px',
        marginBottom: 5,
      }}
    >
      <MicrophoneError type={type} titleOnly={titleOnly} />
    </div>
  );
} 